<a [routerLink]="['/notifications']" aria-label="notifications" class="notifications" [ngClass]="{'has-notifications': notificationCount > 0}">
  <span class="notification-icon material-symbols-outlined icon-filled">notifications</span>
  <div *ngIf="notificationCount > 0" class="dx-badge">{{notificationCount}}</div>
</a>